class QuestionProService {
    private isInitialized = false

    public init(apiKey: string, url: string): void {

        if (this.isInitialized || window.__questionProLoaded__) {
            return
        }

        window.Intercept = { apiKey }

        const script = document.createElement('script')
        script.src = url
        script.async = true
        script.defer = true

        script.onload = () => {
            window.__questionProLoaded__ = true
        }

        script.onerror = () => {
            console.log('[QuestionPro] error al cargar el script.')
        }

        document.head.appendChild(script)

        this.isInitialized = true
    }
}

export const questionProService = new QuestionProService()